import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { getHistoryOfTransactions } from '../api/transaction';
import PageDataLoader from '../pages/Utility/PageDataLoader';

const InvoiceModal = ({ open, handleClose, transactionData }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (transactionData) {
      fetchHistory();
    }
  }, [transactionData]);

  const fetchHistory = async () => {
    setLoading(true);
    const response = await getHistoryOfTransactions({
      child_id: transactionData?.childrenId?._id,
      batch_id: transactionData?.batchId?._id
    });
    console.log(response.data, 'response');
    setHistory(
      response?.data
    );
    setLoading(false);
  };

  const tableStyle = {
    borderCollapse: 'collapse',
    width: '100%'
  };
  const headerStyle = {
    backgroundColor: '#3AA6AE',
    color: 'white'
  };
  const rowStyleEven = {
    backgroundColor: 'white'
  };
  const rowStyleOdd = {
    backgroundColor: '#EAF6F6'
  };
  const cellStyle1 = {
    border: 'none',
    textAlign: 'right'
  };
  const cellStyle2 = {
    border: 'none'
  };

  const downloadInvoice = () => {
    const input = document.getElementById('invoice');
    const scale = 2;
    html2canvas(input, { scale }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`invoice_${transactionData?.batchId?.name}.pdf`);
    });
  };

  // Helper to extract paid date from transaction logs
  const getPaidDate = (item) => {
    if (!item.transactionLogs || !Array.isArray(item.transactionLogs)) return '';
    const successLog = item.transactionLogs.find(log => log.status === 'success');
    if (!successLog || !successLog.timestamp) return '';
    return new Date(successLog.timestamp).toLocaleDateString('en-GB'); // DD/MM/YYYY
  };

  return (
    <Modal isOpen={open} size="xl">
      <ModalHeader toggle={handleClose}>Invoice</ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="text-center">
            <PageDataLoader height={40} width={40} />
          </div>
        ) : (
          <div id="invoice">
            <div
              style={{
                backgroundColor: '#3AA6AE',
                height: '20px',
                width: '100%'
              }}
            ></div>
            <div
              style={{
                width: '100%',
                margin: '0 auto',
                padding: '20px',
                border: '1px outset #ccc'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap'
                }}
              >
                <div style={{ display: 'flex' }}>
                  <div style={{ width: '180px', height: '180px' }}>
                    <img
                      src="/rr_ico.png"
                      alt="Raising Right Logo"
                      style={{ height: '100%', width: '100%' }}
                    />
                  </div>
                  <div
                    style={{
                      display: 'inline-block',
                      paddingTop: '20px',
                      paddingRight: '10px'
                    }}
                  >
                    <h2>Raising Right</h2>
                    <i style={{ fontSize: 14 }}>
                      {transactionData?.address
                        ? transactionData?.address
                        : '5, Kamla Nagar, M.G. Road, Kandivali West'}
                      <br />
                      Mumbai, MH 400067
                    </i>
                    <p style={{ fontSize: 14 }}>
                      8355953059
                      <br />
                      raisingright.education
                      <br />
                      raisingrightpreschool@gmail.com
                    </p>
                  </div>
                </div>
                <div style={{ display: 'flex' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      paddingRight: '20 px',
                      textAlign: 'left'
                    }}
                  >
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        INVOICE
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        {transactionData?.InvoiceID}
                      </p>
                    </span>
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        BATCH NAME
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        {transactionData?.batchId?.name}
                      </p>
                    </span>
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        BATCH TIMING
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        {transactionData?.batchId?.start_time} - {transactionData?.batchId?.end_time}
                      </p>
                    </span>

                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        DATE
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        {new Date(transactionData?.date).toLocaleDateString()}{' '}
                        {new Date(transactionData?.date).toLocaleTimeString()}
                      </p>
                    </span>
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        TOTAL FEES
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        INR ₹
                        {transactionData?.isSessionBatch
                          ? transactionData?.registeredSessions *
                          transactionData?.perSessionFee
                          : transactionData?.batchId?.totalFee}
                      </p>
                    </span>
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        BALANCE DUE
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        INR ₹{Math.round(transactionData?.dueAmount - transactionData?.totalAmountToPay)}
                      </p>
                    </span>
                    {transactionData?.transactionId && <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        TRANSACTION ID
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        {transactionData?.transactionId}
                      </p>
                    </span>}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  margin: '10px 0px 5px 0px'
                }}
              >
                <div>
                  <p>BILL TO</p>
                  <h4>{transactionData?.childrenId?.name}</h4>
                  <i>{transactionData?.childrenId?.address}</i>
                  <p>
                    {transactionData?.childrenId?.phone_number}
                    <br />
                    {transactionData?.childrenId?.email_address}
                  </p>
                </div>
              </div>
              <div>
                <Table style={tableStyle}>
                  <thead>
                    <tr style={headerStyle}>
                      <th style={cellStyle2}>DESCRIPTION</th>
                      <th style={cellStyle1}>RATE</th>
                      <th style={cellStyle1}>QTY</th>
                      <th style={cellStyle1}>AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactionData?.invoiceDetail?.map((item, index) => (
                      <tr
                        key={index}
                        style={index % 2 === 0 ? rowStyleEven : rowStyleOdd}
                      >
                        <td style={cellStyle2}>{item?.description}</td>
                        <td style={cellStyle1}>₹{item?.rate}</td>
                        <td style={cellStyle1}>{item?.quantity}</td>
                        <td style={cellStyle1}>₹{item?.price}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        Initial Amount
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        {transactionData?.totalAmountToPay}
                      </td>
                    </tr>
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        {transactionData?.discountType
                          ? transactionData?.discountType
                          : 'Promotional'}{' '}
                        Discount
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        -₹
                        {transactionData?.discountAmount
                          ? transactionData?.discountAmount
                          : 0}
                      </td>
                    </tr>
                    {!!transactionData?.penaltyAmount &&
                      transactionData?.penaltyAmount > 0 && (
                        <tr>
                          <td style={cellStyle1}></td>
                          <td style={cellStyle1}></td>
                          <td
                            style={{
                              borderTop: '2px solid #CDE9EA ',
                              textAlign: 'right'
                            }}
                          >
                            Late Payment Penalty (
                            {
                              transactionData?.batchId[
                                `quarter${transactionData?.quarter}`
                              ]?.penalty_percentage
                            }
                            %)
                          </td>
                          <td
                            style={{
                              borderTop: '2px solid #CDE9EA ',
                              textAlign: 'right'
                            }}
                          >
                            +₹{transactionData?.penaltyAmount || 0}
                          </td>
                        </tr>
                      )}
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        <b>Total Paid</b>
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        ₹
                        {(transactionData?.paidAmount || 0) +
                          (transactionData?.penaltyAmount || 0) -
                          (transactionData?.discountAmount || 0) || 0}
                      </td>
                    </tr>
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        <b>Past Paid Amount</b>
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        {' '}
                        ₹
                        {transactionData?.isSessionBatch
                          ? transactionData?.perSessionFee *
                          transactionData?.registeredSessions -
                          transactionData?.paidAmount -
                          transactionData?.dueAmount
                          : history[0]?._id?.toString() ===
                            transactionData?._id?.toString()
                            ? 0
                            : (history[0]?.paidAmount || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right',
                          backgroundColor: '#CDE9EA'
                        }}
                      >
                        <b>Balance Due</b>
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right',
                          backgroundColor: '#CDE9EA'
                        }}
                      >
                        INR ₹{Math.round(transactionData?.dueAmount - transactionData?.totalAmountToPay)}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
            <h4 style={{ textAlign: 'center', color: 'grey', marginTop: 20 }}>
              Transaction History
            </h4>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '0px 20px'
              }}
            >
              {history.length <= 0 ? <p>No previous transactions!</p> : null}
              {history.length > 0 && (
                <table
                  style={{
                    borderStyle: 'outset',
                    borderWidth: '0.1px',
                    borderColor: '#078691',
                    width: '100%',
                    margin: '15px 35px'
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Transaction ID
                      </th>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Due Date (DD/MM/YYYY)
                      </th>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Paid Date
                      </th>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Amount Paid
                      </th>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Due Amount
                      </th>
                      {history.some((item) => item?.isSessionBatch) && (
                        <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                          Registered Sessions
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {history.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          borderStyle: 'solid',
                          borderWidth: '0.1px',
                          padding: '5px',
                          borderColor: '#078691',
                          backgroundColor: item?.isPaid ? '#F5F5F5' : '#CDE9EA'
                        }}
                      >
                        <td style={{ textAlign: 'center' }}>
                          <strong>{item?.InvoiceID}</strong>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <strong>
                            {new Date(item?.dueDate).toLocaleDateString("en-GB")}
                          </strong>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {getPaidDate(item)}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {item?.paidAmount !== 0 && "INR"}{' '}
                          {item?.paidAmount === 0 ? `Next Payment (INR ${item?.totalAmountToPay + item?.penaltyAmount - item?.discountAmount})` : (item?.paidAmount )}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          INR {item?.dueAmount}
                        </td>
                        {item?.isSessionBatch && (
                          <td style={{ textAlign: 'center' }}>
                            {item?.registeredSessions}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div style={{
              color: 'red',
              textAlign: 'center',
              margin: '20px 0',
              fontWeight: 'bold',
              fontSize: '14px',
              padding: '10px',
            }}>
              Note: In case of any cancellation, instalment already paid are strictly not refundable. After due date of each instalment late fee will be applicable.
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={downloadInvoice}>
          Download Invoice
        </Button>
        <Button color="secondary" onClick={handleClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default InvoiceModal;